import { Grid, Typography } from '@mui/material';
import React from 'react';

export default function MiniWebSiteFooter() {
  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ gap: '8px', marginTop: 'auto', marginBottom: '10px' }}
    >
      <Typography variant="tinyTexts" color="primary">
        {new Date().getFullYear()} Progress Magic. All rights reserved
      </Typography>
      <Typography
        variant="caption2Bold"
        color="primary"
        sx={{ textDecoration: 'none', cursor: 'pointer' }}
        onClick={() => {
          window.open('https://www.progressmagic.com/privacy-policy');
        }}
      >
        Privacy Policy
      </Typography>
    </Grid>
  );
}
